module.exports = __webpack_public_path__ + "img/emblem.da1a05ae.png";